import React, { useEffect, useState } from "react";
import { FiUpload } from "react-icons/fi";
import { IoMdArrowDropdown } from "react-icons/io";
import { IoChevronDown } from "react-icons/io5";
import styled from "styled-components";
import { Notify, Utils } from "../../utils";
import { ExpenseService } from "../../_service/ExpenseService";
import { useAppSelector } from "../../_app";
import ReactDatePicker from "react-datepicker";
import moment from "moment";
import { FaArrowLeft, FaArrowLeftLong } from "react-icons/fa6";
import { Box } from "@mui/material";

const ExpenseSubmitForm = (props: any) => {
  const [data, setData] = useState<any>(props.data || {});
  let fillData = Boolean(data?.id);

  const isDisabled = data?.status && data?.status !== "draft";

  const [amount, setAmount] = useState(fillData ? data?.purchase_amount : "");
  const [currency, setCurrency] = useState("SGD");
  const [description, setDescription] = useState<string>(
    fillData ? data?.description : ""
  );
  const [paymentType, setPaymentType] = useState<string>(
    fillData ? (data?.is_reimbursable ? "personal" : "company") : "company"
  );
  const [bankAccount, setBankAccount] = useState("");
  const [accountId, setAccountId] = useState(
    fillData ? data?.custom_input_item?.id : ""
  );
  const [spentAt, setSpentAt] = useState(fillData ? data?.spent_at : "");
  const [spentOn, setSpentOn] = useState<Date | null>(
    fillData ? new Date(data?.spent_on) : null
  );
  const [account, setAccount] = useState("");
  const [assignedTo, setAssignedTo] = useState("");
  const [file, setFile] = useState<File | null>(
    fillData ? Utils.convertBlobToFile(data?.document) : null
  );

  // Add validation state
  const [errors, setErrors] = useState<Record<string, string>>({});

  // Helper function to convert blob string to File

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [expenseItems, setExpenseItems] = useState<any[]>([]);

  const companyId = useAppSelector((state: any) => state.user.defaultCompnayId);
  const user = useAppSelector((state: any) => state.user);

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files.length > 0) {
      const selectedFile = e.target.files[0];
      const allowedExtensions = ["pdf", "jpg", "jpeg", "png"];
      const fileExtension = selectedFile.name.split(".").pop()?.toLowerCase();

      if (!fileExtension || !allowedExtensions.includes(fileExtension)) {
        // You'll need to install react-toastify: npm install react-toastify
        // And import: import { toast } from 'react-toastify';
        Notify("Please select a valid file format (PDF, JPG, JPEG, PNG)", 0);
        e.target.value = ""; // Clear the input
        return;
      }

      setFile(selectedFile);
    }
  };

  const getInitials = (name: string) => {
    return name
      .split(" ")
      .map((n) => n?.[0])
      .join("");
  };

  const getExpenseItems = async () => {
    setIsLoading(true);
    try {
      const res = await ExpenseService._getExpenseItems(companyId);
      if (res.status === 200) {
        let data = res?.data?.data || [];
        setExpenseItems(data?.filter((item: any) => item.is_checked));
      }
    } catch (e: any) {
      Utils.showErrorMessage(e);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    getExpenseItems();
  }, []);

  // Add validation function
  const validateFields = () => {
    const newErrors: Record<string, string> = {};

    if (!amount) newErrors.amount = "Purchase amount is required";
    if (!description) newErrors.description = "Description is required";
    if (!spentAt) newErrors.spentAt = "Spent at field is required";
    if (!spentOn) newErrors.spentOn = "Spent on date is required";
    if (!accountId) newErrors.accountId = "Account selection is required";
    if (!file) newErrors.file = "File upload is required";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleAction = async (status: string) => {
    if (!validateFields()) {
      Notify("Please fill in all required fields", 0);
      return;
    }
    if (!file) {
      Notify("Please upload a file", 0);
      return;
    }
    setIsLoading(true);
    try {
      const formData = new FormData();
      formData.append("claim_document", file);
      formData.append("purchase_amount", amount.toString());
      formData.append("currency", currency);
      formData.append("description", description);
      formData.append(
        "is_reimbursable",
        paymentType === "personal" ? "true" : "false"
      );
      formData.append("spent_at", spentAt);
      formData.append(
        "spent_on",
        spentOn ? moment(spentOn).format("YYYY-MM-DD") : ""
      );
      formData.append("company", companyId);
      formData.append("custom_input_item", accountId);
      formData.append("status", status);

      const res = data?.id ? await ExpenseService._updateExpenseClaim(data.id, formData) : await ExpenseService._submitExpenseClaim(formData);
      if (res.status >= 200 && res.status < 300) {
        Notify("Expense claim submitted successfully", 1);
        // Reset form fields
        props.closeDrawer();
        setAmount("");
        setCurrency("SGD");
        setDescription("");
        setPaymentType("company");
        setSpentAt("");
        setSpentOn(null);
        setAccountId("");
        setFile(null);
        setExpenseItems([]);
        setAccount("");
        setErrors({});
      }
    } catch (e: any) {
      Utils.showErrorMessage(e);
    }
    setIsLoading(false);
  };

  // Clear specific error when user starts typing
  const clearError = (field: string) => {
    if (errors[field]) {
      setErrors(prev => ({ ...prev, [field]: "" }));
    }
  };

  console.log("submit stateData", {
    amount,
    currency,
    description,
    paymentType,
    spentAt,
    spentOn,
    account,
    file,
    expenseItems,
    accountId,
    formatted: moment(spentOn).format("YYYY-MM-DD"),
  });

  console.log("Drawer inside", fillData, "data", data);

  return (
    <div>
      <Header>
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <FaArrowLeftLong
            size={24}
            style={{ 
              cursor: "pointer", 
              marginRight: "0.5rem",
            }}
            onClick={props.closeDrawer}
        />
        <Title>{fillData ? "Expense Claims" : "New Expense Claims"}</Title>
        </Box>
        <ActionButtons>
          <Button
            variant="outline"
            onClick={() => handleAction("draft")}
            disabled={isDisabled}
          >
            Save as Draft
          </Button>
          <Button
            variant="primary"
            onClick={() => handleAction("submitted")}
            disabled={isDisabled}
          >
            Submit
          </Button>
        </ActionButtons>
      </Header>

      <Container>
        <LeftSection>
          {file || fillData ? (
            <div
              style={{
                width: "100%",
                height: "100%",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <div
                style={{
                  flex: 1,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginBottom: "1rem",
                  overflow: "hidden",
                }}
              >
                {file?.type === "application/pdf" || data?.document_type === "application/pdf" ? (
                  <iframe
                    src={fillData ? data?.document_url : URL.createObjectURL(file)}
                    style={{
                      width: "100%",
                      height: "100%",
                      border: "1px solid #ccc",
                      borderRadius: "4px",
                    }}
                    title="PDF Preview"
                  />
                ) : (
                  <img
                    src={fillData ? data?.document_url : URL.createObjectURL(file)}
                    alt="Preview"
                    style={{
                      maxWidth: "100%",
                      maxHeight: "100%",
                      objectFit: "contain",
                      borderRadius: "4px",
                    }}
                  />
                )}
              </div>
              <div style={{ textAlign: "center", marginTop: "auto" }}>
                <p
                  style={{
                    margin: "0 0 0.5rem 0",
                    fontSize: "13px",
                    fontWeight: "bold",
                  }}
                >
                  {file?.name}
                </p>
                <UploadLabel
                  htmlFor="file-upload"
                  style={{
                    border: isDisabled ? "1px solid #ccc" : "1px solid #28a745",
                    color: isDisabled ? "#ccc" : "#28a745",
                    cursor: isDisabled ? "not-allowed" : "pointer",
                    backgroundColor: isDisabled ? "#f8f8f8" : "transparent",
                    pointerEvents: isDisabled ? "none" : "auto",
                  }}
                >
                  Change File
                </UploadLabel>
              </div>
            </div>
          ) : (
            <>
              <FiUpload size={60} color="#777" />
              <UploadText>
                Upload an image or PDF <RequiredStar>*</RequiredStar>
              </UploadText>
              <UploadHint>
                select your file manually (PDF, JPG, JPEG, PNG)
              </UploadHint>
              <UploadLabel htmlFor="file-upload">Upload</UploadLabel>
            </>
          )}
          <UploadInput
            id="file-upload"
            type="file"
            accept=".pdf,.jpg,.jpeg,.png"
            onChange={(e) => {
              handleFileChange(e);
              clearError('file');
            }}
            disabled={isDisabled}
          />
          {errors.file && <ErrorMessage>{errors.file}</ErrorMessage>}
        </LeftSection>

        <RightSection>
          <FormGroup style={{ marginBottom: "2rem" }}>
            <div
              style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}
            >
              <Avatar>{getInitials(user?.name)}</Avatar>
              <span
                style={{ fontWeight: "600", color: "#333", fontSize: "1.2rem" }}
              >
                {user?.name} (You)
              </span>
              <IoMdArrowDropdown size={30} />
            </div>
          </FormGroup>

          <FormGroup>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Label>
                Purchase Amount <RequiredStar>*</RequiredStar>
              </Label>
              <Label style={{ color: "#28a745", marginBottom: 0 }}>
                Itemise
              </Label>
            </div>
            <div style={{ display: "flex", alignItems: "center" }}>
              <Select
                style={{
                  padding: "7px",
                  border: "1px solid #ccc",
                  borderRight: "none",
                  borderRadius: "4px 0 0 4px",
                }}
                value={currency}
                onChange={(e) => setCurrency(e.target.value)}
                disabled={isDisabled}
              >
                <option value="SGD">SGD</option>
              </Select>

              <Input
                style={{
                  flex: 1,
                  padding: "8px",
                  border: "1px solid #ccc",
                  borderRadius: "0 4px 4px 0",
                }}
                placeholder="Enter amount"
                value={amount}
                onChange={(e) => {
                  setAmount(e.target.value);
                  clearError('amount');
                }}
                disabled={isDisabled}
              />
            </div>
            {errors.amount && <ErrorMessage>{errors.amount}</ErrorMessage>}
          </FormGroup>

          <FormGroup>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Label>
                Description <RequiredStar>*</RequiredStar>
              </Label>
              <Label style={{ color: "#28a745", marginBottom: 0 }}>
                {description.length}/1000
              </Label>
            </div>
            <TextArea
              rows={4}
              maxLength={1000}
              placeholder="Enter description"
              value={description}
              onChange={(e) => {
                setDescription(e.target.value);
                clearError('description');
              }}
              disabled={isDisabled}
            />
            {errors.description && <ErrorMessage>{errors.description}</ErrorMessage>}
          </FormGroup>

          <FormGroup>
            <Label>How did you pay?</Label>
            <div
              style={{ display: "flex", alignItems: "center", gap: ".4rem" }}
            >
              <RadioInput
                type="radio"
                id="company"
                name="payment"
                checked={paymentType === "company"}
                onChange={() => setPaymentType("company")}
                disabled={isDisabled}
              />
              <RadioLabel htmlFor="company">
                Company money (non-reimbursable)
              </RadioLabel>
            </div>
            <div
              style={{ display: "flex", alignItems: "center", gap: ".4rem" }}
            >
              <RadioInput
                type="radio"
                id="personal"
                name="payment"
                checked={paymentType === "personal"}
                onChange={() => setPaymentType("personal")}
                disabled={isDisabled}
              />
              <RadioLabel htmlFor="personal">
                Personal money (reimbursable)
              </RadioLabel>
            </div>
          </FormGroup>

          <FormGroup>
            <div style={{ display: "flex", gap: "1rem" }}>
              <div
                style={{ display: "flex", flexDirection: "column", flex: 1 }}
              >
                <Label>
                  Spent At <RequiredStar>*</RequiredStar>
                </Label>
                <Input
                  value={spentAt}
                  onChange={(e) => {
                    setSpentAt(e.target.value);
                    clearError('spentAt');
                  }}
                  disabled={isDisabled}
                />
                {errors.spentAt && <ErrorMessage>{errors.spentAt}</ErrorMessage>}
              </div>
              <div
                style={{ display: "flex", flexDirection: "column", flex: 1 }}
              >
                <Label>
                  Spent On <RequiredStar>*</RequiredStar>
                </Label>
                <StyledDatePicker
                  selected={spentOn}
                  onChange={(date) => {
                    setSpentOn(Array.isArray(date) ? date[0] : date);
                    clearError('spentOn');
                  }}
                  dateFormat="dd-MM-yyyy"
                  placeholderText="DD-MM-YYYY"
                  disabled={isDisabled}
                />
                {errors.spentOn && <ErrorMessage>{errors.spentOn}</ErrorMessage>}
              </div>
            </div>
          </FormGroup>

          <FormGroup>
            <Label>
              Account <RequiredStar>*</RequiredStar>
            </Label>
            <Select
              value={accountId}
              onChange={(e) => {
                setAccountId(e.target.value);
                clearError('accountId');
              }}
              disabled={isDisabled}
            >
              {expenseItems?.length > 0 ? (
                <>
                  <option value="">Select account</option>
                  {expenseItems?.map((item) => (
                    <option
                      key={item.custom_input_id}
                      value={item.custom_input_id}
                    >
                      {item.name}
                    </option>
                  ))}
                </>
              ) : (
                <option value="">No accounts available</option>
              )}
            </Select>
            {errors.accountId && <ErrorMessage>{errors.accountId}</ErrorMessage>}
          </FormGroup>

          <Summary>
            <SummaryRow>
              <div>Subtotal before GST</div>
              <div>
                {Utils.getCommanSepartedNumericStringWithDollar(amount)}
              </div>
            </SummaryRow>
            <SummaryRow>
              <div>GST</div>
              <div>0.00</div>
            </SummaryRow>
            <GrandTotalRow>
              <div>Grand Total</div>
              <div>
                {Utils.getCommanSepartedNumericStringWithDollar(amount)}
              </div>
            </GrandTotalRow>
          </Summary>
        </RightSection>
      </Container>
    </div>
  );
};

export default ExpenseSubmitForm;

// Add new styled components
const RequiredStar = styled.span`
  color: #dc3545;
  margin-left: 2px;
`;

const ErrorMessage = styled.div`
  color: #dc3545;
  font-size: 12px;
  margin-top: 4px;
`;

const Avatar = styled.div<{ bg?: string }>`
  background: ${({ bg }) => bg || "rgb(230, 230, 250)"};
  color: black;
  font-weight: bold;
  width: 38px;
  height: 38px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
`;

const Container = styled.div`
  display: flex;
  gap: 2rem;
  padding: 2rem;
  height: calc(100vh - 80px);
  overflow: hidden;
`;

const LeftSection = styled.div`
  background: #f8f8f8;
  border: 1px dashed #ccc;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  text-align: center;
  width: 50%;
`;

const UploadText = styled.p`
  color: #2b2f32;
  font-weight: bold;
  margin: 0;
`;

const UploadHint = styled.p`
  color: #777;
  font-size: 14px;
  margin: 0.5rem 0;
`;

const UploadInput = styled.input`
  display: none;
`;

const UploadLabel = styled.label`
  padding: 0.4rem 1.2rem;
  border: 1px solid #28a745;
  background-color: transparent;
  color: #28a745;
  border-radius: 4px;
  cursor: pointer;
  margin-top: 1rem;

  &:hover {
    background-color: #28a745;
    color: white;
  }
`;

const RightSection = styled.div`
  flex: 1;
  overflow-y: scroll;
  max-height: 100%;
  padding-right: 1rem;

  //   /* Optional: WebKit scrollbar styling */
  //   &::-webkit-scrollbar {
  //     width: 8px;
  //   }

  //   &::-webkit-scrollbar-thumb {
  //     background-color: #ccc;
  //     border-radius: 4px;
  //   }

  //   &::-webkit-scrollbar-track {
  //     background-color: #f0f0f0;
  //   }
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 1rem;
  border-bottom: 1px solid #ccc;
`;

const Title = styled.h2`
  margin: 0;
`;

const ActionButtons = styled.div`
  display: flex;
  gap: 1rem;
`;

interface ButtonProps {
  variant?: "primary" | "outline" | "default";
}

const Button = styled.button<ButtonProps>`
  padding: 0.4rem 1rem;
  border-radius: 4px;
  border: 1px solid;
  cursor: pointer;
  font-weight: medium;

  ${({ variant }) =>
    variant === "primary"
      ? `background: #28a745; color: white; border-color: #28a745;`
      : variant === "outline"
      ? `background: transparent; color: #000; border-color: #ccc;`
      : `background: #ffffff; border-color: #28a745; color: #28a745`}

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

const FormGroup = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 1rem;
`;

const Label = styled.label`
  font-size: 14px;
  margin-bottom: 0.25rem;
`;

const Input = styled.input`
  padding: 0.4rem;
  border: 1px solid #ccc;
  border-radius: 4px;

  &:disabled {
    background-color: #f5f5f5;
    cursor: not-allowed;
  }
`;

const TextArea = styled.textarea`
  padding: 0.5rem;
  border: 1px solid #ccc;
  border-radius: 4px;
  resize: vertical;

  &:disabled {
    background-color: #f5f5f5;
    cursor: not-allowed;
  }
`;

const Summary = styled.div`
  margin-top: 2rem;
`;

const SummaryRow = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 0.5rem;
  font-size: 14px;
`;

const GrandTotalRow = styled(SummaryRow)`
  font-weight: bold;
  font-size: 16px;
  margin-top: 1rem;
  border-top: 1px solid #ccc;
  padding-top: 1rem;
`;

const RadioLabel = styled.label`
  font-size: 14px;
`;

const RadioInput = styled.input`
  accent-color: #28a745;
`;

const Select = styled.select`
  padding: 0.4rem;
  border: 1px solid #ccc;
  border-radius: 4px;

  &:disabled {
    background-color: #f5f5f5;
    cursor: not-allowed;
  }
`;

const StyledDatePicker = styled(ReactDatePicker)`
  padding: 0.4rem;
  border: 1px solid #ccc;
  border-radius: 4px;
  width: 100%;

  &:disabled {
    background-color: #f5f5f5;
    cursor: not-allowed;
  }
`;
